import { useSyncExternalStore } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '@/components/modals/ConfirmationModal/ConfirmationModal';
import {
  cancelLogoutDraftPrompt,
  chooseSaveDraftBeforeLogout,
  discardLogoutDraftAndContinue,
  getLogoutDraftPrompt,
  subscribeLogoutDraftPrompt,
} from '@/helpers/messageCreatorLogoutGuard';
import { ROUTE_ALIASES } from '@/routing/routesAliases';
import dayjs from '@/utils/dayjs';

const subscribe = (listener: () => void) => subscribeLogoutDraftPrompt({ listener });

export const LogoutMessageDraftModal = () => {
  const { t } = useTranslation('global');
  const navigate = useNavigate();
  const prompt = useSyncExternalStore(subscribe, getLogoutDraftPrompt, getLogoutDraftPrompt);

  const handleDiscardAndLogout = () => {
    void discardLogoutDraftAndContinue();
  };

  const handleSaveDraft = () => {
    chooseSaveDraftBeforeLogout();
    navigate(ROUTE_ALIASES.MESSAGES_CREATE, {
      state: {
        autoRestoreLocalDraft: true,
        logoutAfterDraftSave: true,
      },
    });
  };

  const handleStaySignedIn = () => {
    cancelLogoutDraftPrompt();
  };

  return (
    <ConfirmationModal
      opened={Boolean(prompt)}
      onClose={handleStaySignedIn}
      onCancel={handleDiscardAndLogout}
      onConfirm={handleSaveDraft}
      title={t('message.logoutUnsavedMessageTitle')}
      message={t('message.logoutUnsavedMessageText', {
        time: prompt ? dayjs(prompt.updatedAt).format('MMM D, YYYY, h:mm A') : '',
      })}
      confirmLabel={t('message.logoutUnsavedMessageSaveDraft')}
      cancelLabel={t('message.logoutUnsavedMessageDiscardAndLogout')}
      color="brand"
      closeOnClickOutside={false}
      closeOnEscape={false}
    />
  );
};
